export enum Action {
    READ = 'READ',
    // OWN_READ = 'OWN_READ',
    WRITE = 'WRITE',
    // OWN_WRITE = 'OWN_WRITE',
    DELETE = 'DELETE',
    // OWN_DELETE = 'OWN_DELETE',
}

export enum Subject {
    DASHBOARD = 'DASHBOARD',
    PROJECT = 'PROJECT',
    TEAMTASK = 'TEAMTASK',
    CAPA = 'CAPA',
    CARDS = 'CARDS',
    INBOX = 'INBOX',
    ANNOUNCEMENTS = 'ANNOUNCEMENTS',
    GOALS = 'GOALS',
    CALENDAR = 'CALENDAR',
    REVIEWS = 'REVIEWS',
    DRIP = 'DRIP',
    
    LEADERBOARD = 'LEADERBOARD',
    USERS = 'USERS',

    PERMISSIONS = 'PERMISSIONS',
    CONTROLPANEL = 'CONTROLPANEL',
}